import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/form'
import { Switch } from '@/components/shadcn/switch'
import { BaseFieldProps } from './types'
import clsx from 'clsx'

export const BooleanField: React.FC<BaseFieldProps> = ({ field, formFieldName, control }) => {
  return (
    <FormField
      control={control}
      name={formFieldName}
      render={({ field: formField }) => (
        <FormItem className={clsx('flex flex-col gap-1', field.widget === 'hidden' && 'hidden')}>
          <div className="flex items-center gap-2">
            <FormControl>
              <Switch
                checked={formField.value as boolean}
                onCheckedChange={formField.onChange}
                disabled={field.readonly}
              />
            </FormControl>
            <FormLabel>{field.title}</FormLabel>
          </div>
          {field.description && <FormDescription>{field.description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
